import { jsxs, jsx } from "react/jsx-runtime";
import { useTheme } from "@mui/material";
import { sectionFadeInStyle, GREY_PLACEHOLDER_SVG } from "./utils.js";
import { getAppConsistentParams } from "../../../utils/appUtils.js";
import { getProductUrl } from "../../../utils/productUtils.js";
const formatReviewCount = (count) => {
  if (count >= 1e3) {
    const k = count / 1e3;
    return k % 1 === 0 ? `${k}K` : `${k.toFixed(1)}K`;
  }
  return count.toLocaleString();
};
const StarIcon = () => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.4819 6.07562C15.4285 5.8977 15.2864 5.76804 15.1153 5.74117L10.3089 4.98558L8.1594 0.273902C8.0829 0.106169 7.92499 0 7.75211 0C7.5792 0 7.42132 0.106169 7.3448 0.273902L5.19518 4.98558L0.388901 5.74117C0.217838 5.76804 0.0756731 5.89771 0.0222526 6.07558C-0.0311937 6.2535 0.0133808 6.44878 0.137199 6.57932L3.61497 10.2469L2.7941 15.4256C2.76485 15.6099 2.83492 15.7962 2.97479 15.9062C3.05391 15.9684 3.14764 16 3.24182 16C3.31413 16 3.38668 15.9814 3.45312 15.9436L7.75208 13.4985L12.0509 15.9435C12.204 16.0306 12.3894 16.0161 12.5292 15.9061C12.6691 15.7962 12.7392 15.6099 12.71 15.4255L11.8888 10.2469L15.367 6.5793C15.4908 6.44879 15.5354 6.2535 15.4819 6.07562H15.4819Z",
        fill: "#ED792F"
      }
    )
  }
);
function PdpProductInfoPart({ part }) {
  const data = part.data;
  if (!(data == null ? void 0 : data.stacklineSku)) return null;
  const { title, imageUrl, rating, reviewsCount, stacklineSku } = data;
  const theme = useTheme();
  const primaryColor = theme.palette.primary.main;
  const primaryContrastText = theme.palette.primary.contrastText;
  const urlSearchParams = getAppConsistentParams(window.location.search);
  const pdpUrl = getProductUrl({ title, stacklineSku, urlSearchParams });
  return /* @__PURE__ */ jsxs("div", { style: { animation: "concierge-fade-in 0.35s ease-out both" }, children: [
    /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: 16,
          border: "1px solid #dcdddc",
          borderRadius: 10,
          gap: 16,
          minHeight: 80,
          boxSizing: "border-box"
        },
        children: [
          /* @__PURE__ */ jsxs("div", { style: { display: "flex", alignItems: "center", gap: 8, minWidth: 0, flex: 1 }, children: [
            /* @__PURE__ */ jsx(
              "img",
              {
                src: imageUrl || GREY_PLACEHOLDER_SVG,
                alt: title,
                style: {
                  width: 48,
                  height: 48,
                  objectFit: "contain",
                  flexShrink: 0,
                  alignSelf: "flex-start"
                }
              }
            ),
            /* @__PURE__ */ jsxs(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  columnGap: 16,
                  rowGap: 2,
                  minWidth: 0,
                  flex: 1
                },
                children: [
                  /* @__PURE__ */ jsx(
                    "span",
                    {
                      style: {
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 600,
                        fontSize: 14,
                        lineHeight: "24px",
                        color: primaryColor,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minWidth: 120,
                        maxWidth: 380,
                        flex: 1
                      },
                      children: title
                    }
                  ),
                  rating != null && rating > 0 && /* @__PURE__ */ jsxs(
                    "span",
                    {
                      style: {
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 8,
                        flexShrink: 0
                      },
                      children: [
                        /* @__PURE__ */ jsx(StarIcon, {}),
                        /* @__PURE__ */ jsxs(
                          "span",
                          {
                            style: {
                              fontFamily: "'Poppins', sans-serif",
                              fontWeight: 500,
                              fontSize: 12,
                              lineHeight: "16px",
                              color: primaryColor,
                              whiteSpace: "nowrap"
                            },
                            children: [
                              rating.toFixed(1),
                              reviewsCount != null && reviewsCount > 0 && ` (${formatReviewCount(reviewsCount)} reviews)`
                            ]
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          ] }),
          pdpUrl && /* @__PURE__ */ jsx(
            "a",
            {
              href: pdpUrl,
              style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: 40,
                padding: "12px 24px",
                backgroundColor: primaryColor,
                color: primaryContrastText,
                borderRadius: 100,
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
                fontSize: 14,
                lineHeight: "22px",
                textDecoration: "none",
                whiteSpace: "nowrap",
                flexShrink: 0,
                border: `1px solid ${primaryColor}`
              },
              children: "View"
            }
          )
        ]
      }
    )
  ] });
}
export {
  PdpProductInfoPart
};
//# sourceMappingURL=PdpProductInfoPart.js.map
